import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconsModule } from '@fcom/ui-components';
import { PipesModule } from '@fcom/common/pipes/pipes.module';
import { ComponentsModule } from '@fcom/common/components/components.module';

import { TabGroupComponent } from './tab-group.component';
import { TabHeaderComponent } from './tab-header.component';
import { TabLabelComponent } from './tab-label.component';
import { TabComponent } from './tab.component';

// Missing stuff that could be handy at some point:
// - disabled tabs
// - vertical layout
// - custom tab styling

const COMPONENTS = [TabHeaderComponent, TabLabelComponent, TabGroupComponent, TabComponent];

@NgModule({
  imports: [CommonModule, ComponentsModule, PipesModule, IconsModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class TabsModule {}
